import { useState } from "react";
import { X } from "lucide-react";
import xCircleIcon from "../../assets/icons/exit-icon.svg";

export default function ModalUserInfoForChatWithCS({
  onClose,
  formData,
  setFormData,
  onCloseModal,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !formData.name ||
      !formData.name.trim() ||
      !formData.email ||
      !formData.email.trim() ||
      !formData.issue ||
      !formData.issue.trim()
    ) {
      alert("Please fill in all fields");
      return;
    }
    console.log("Form submitted:", formData);
    alert(
      `Thank you for raising your concern. Our support team will connect with you shortly. Please do not close or exit your browser while we get someone to assist you.`
    );
    console.log(formData);
    onCloseModal();
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="fixed flex flex-col inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 gap-y-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full relative">
        <div className="bg-[#215732] text-white p-4 rounded rounded-t-xs flex justify-between items-center">
          <h2 className="text-xl font-bold">Report an Issue</h2>
          <img src={xCircleIcon} className="flex-shrink-0" onClick={onClose} />
        </div>
        <div className="p-6">
          <div className="space-y-4">
            {/* <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                placeholder="Your name"
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                placeholder="your.email@example.com"
              />
            </div> */}

            <div>
              <label
                htmlFor="issue"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Issue Description
              </label>
              <textarea
                id="issue"
                name="issue"
                value={formData.issue}
                onChange={handleChange}
                rows="4"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all resize-none"
                placeholder="Describe your issue..."
              />
            </div>
          </div>
        </div>
      </div>

      <div className="px-6 pb-6">
        <button
          onClick={handleSubmit}
          className={`w-[120px] bg-[#A09200] text-white py-2 px-4 rounded-md transition-colors font-medium`}
        >
          Submit
        </button>
      </div>
    </div>
  );
}
